import Dollarsign from './Dollarsign';

export default Dollarsign;
